import React, { useState, useEffect } from "react";

import { useDispatch, useSelector } from "react-redux";

import { Link, useSearchParams, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { getCategorySelection,getCorporateInformationFragment } from "../containers/categorySlice/categorySlice";

import CategoryCard from "../components/CategoryCard/CategoryCards";
import { checkReplaceUrl, getCurrentLocal } from "../utils";

const CategorySelection = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [searchParams, setSearchParams] = useSearchParams();
    const [level, setLevel] = useState([{ level: 1, value: '' }]);
    const categoriesSelection = useSelector((state) => state?.categorySelection?.categories);
    const corpInfo = useSelector((state) => state?.categorySelection?.corporateInfo);
    const isApiLoading = useSelector((state) => state?.categorySelection?.loading);
    const getcurrentloc = getCurrentLocal().toLowerCase()
    const currentloc = getcurrentloc == 'en-us'? '': '/'+getcurrentloc
    
    let ignore = false;
    let host = window.location.host;
    const isMobile = window.innerWidth < 1024;

    useEffect(() => {
        if (!ignore) {
            setLevel([{ level: 1, value: '' }])
            dispatch(getCorporateInformationFragment())

            // getCorporateInformationFragment();
            const category = searchParams.get('cat');
            const subCategory = searchParams.get('sub-cat');
            if (category && subCategory === null) {
                let temp = [{ level: 2, value: category }]
                setLevel(prev => [...prev, ...temp])
                getData('subCategoryImageId_s', 'categoryImageId_s:' + category)
            }
            if ((subCategory && category === null) || (subCategory && category)) {
                let temp = [{ level: 2, value: category }, { level: 3, value: subCategory }]
                setLevel(prev => [...prev, ...temp])
                getData('subject', 'subCategoryImageId_s:' + subCategory)
            }
            if (category === null && subCategory === null) {
                getData('categoryImageId_s')
            }
        }
        return () => {
            ignore = true;
        }
    }, [searchParams.toString()]);


    // const getCorporateInformationFragment = () => {
    //     dispatch(getCorporateInformationFragment())
        // fetch('https://www-stage.sandisk.com/content/experience-fragments/sndsk/newsroom/latest-corporate-information/master')
        //     .then(response => response.text())
        //     .then(data => {
        //         const parser = new DOMParser();
        //         const doc = parser.parseFromString(data, 'text/html');
        //         const corporateInformationFragment = doc.querySelector('.cmp-container');
        //         console.log(corporateInformationFragment,'data')
        //         document.getElementById('corporate-information').innerHTML = corporateInformationFragment.innerHTML;
        //     });
    // }

    const getData = async (groupBy, fq = '') => {
        let loc = '&locale=' + getCurrentLocal().toLowerCase()
        let documentType = '&documentType=Support Products'
        let group = '&groupBy=' + groupBy
        let finalQuery = '?q=*' + loc + documentType + group
        if (fq !== '') {
            finalQuery = finalQuery + '&fq=' + fq
        }
        await dispatch(getCategorySelection(finalQuery))
    }

    const handleCategoryClick = async (category,URLlink='') => {
        const currentlevel = level[level.length - 1];

        const newSearchParams = new URLSearchParams(searchParams);

        if (currentlevel.level + 1 === 2) {
            newSearchParams.set('cat', category);
            navigate(`?${newSearchParams.toString()}`);
            // await getData('subCategoryImageId_s', 'categoryImageId_s:' + category)
        }
        else if (currentlevel.level + 1 === 3) {
            newSearchParams.set('sub-cat', category);
            navigate(`?${newSearchParams.toString()}`);
            // await getData('subject', 'subCategoryImageId_s:' + category)
        }
        else if (currentlevel.level + 1 === 4 ) {
            window.open(categoriesSelection[category][0]?.url, "_blank", "noopener,noreferrer");
            // await getData('subject', 'subCategoryImageId_s:' + category)
        }

    }


    const gotoPrevious = async () => {
        document.getElementById('category-list').scrollIntoView({ behavior: 'smooth' });
        const newSearchParams = new URLSearchParams(searchParams);
        let currentlevel = level[level.length - 2]
        navigate(-1)
        // if (currentlevel.level === 2) {
        //     newSearchParams.delete('sub-cat');
        //     navigate(`?${newSearchParams.toString()}`);
        // }
        // else if (currentlevel.level === 1) {
        //     newSearchParams.delete('cat');
        //     navigate(`?${newSearchParams.toString()}`);
        // }
        // document.getElementById('category-back-btn').classList.remove('active');
    }

    const formatText = (text) => {
        return text
            .split('-')
            .map(word => word.charAt(0).toUpperCase() + word.slice(1))
            .join(' ');
    };

    return (
        <section className="sd-relative">
            <div className="sd-container">
                <div className="sd-grid lg:sd-grid-cols-16 sd-grid-cols-8 lg:sd-gap-4">
                    <div className="lg:sd-h-screen-minus-48 sd-flex sd-flex-col lg:sd-col-span-4 sd-col-span-8 lg:sd-border-r lg:sd--ml-4 lg:sd-sticky lg:sd-top-[48px] lg:sd-z-10 ">
                        <div className="sd-px-4 lg:sd-border-b ">
                           
                        <a href={currentloc+'/support'} className="lg:sd-py-[2rem] sd-py-[1rem]  sd-hidden lg:sd-block  sd-font-nb  sd-sdList lg:sd-col-span-8 sd-col-span-4 sd-uppercase sd-titleText">{t('backToSupport')}</a>
                        </div>
                    </div>
                    <div className="lg:sd-gap-4 sd-col-span-8 lg:sd-col-span-12 lg:sd-col-start-5 sd-pt-4 sd-mb-10">
                        
                        <div className="sd-lg:p-12 lg:sd-col-span-12 sd-col-span-8">
                            {/* <div className="">
                                <h1 className="lg:sd-titleText lg:sd-font-nb sd-mb-10 sd-font-pilat sd--tracking-[0.28px] sd-text-[28px] lg:sd-text-[13px]">{t('welcome')} </h1>
                                <div className="sd-my-2">
                                    <h2 className="sd-mb-4 lg:sd-text-[40px] sd-font-pilat sd-text-[28px] sd-leading-[110%]">
                                        {t('Media+Kits')}
                                    </h2>
                                    <p className="sd-mb-2 sd-font-pilat lg:sd-text-[23px] lg:sd--tracking-[0.23px] sd-text-[19px]">
                                        {t('looking')} 
                                    </p>
                                    <p>
                                    {t('visit')}
                                        <a href="https://www.westerndigital.com/support" target="_blank" rel="noopener noreferrer" className="sd-underline sd-text-black hover:sd-no-underline sd-px-2">
                                            {t('westernLink')}
                                        </a>
                                    </p>


                                </div>

                            </div> */}
                                    <div className="sd-col-span-8 lg:sd-col-span-12 ">
                                        <img src={require('../assets/images/supporthero.jpg')} className="sd-w-full sd-h-full sd-object-cover sd-pb-4" alt="SanDisk Support" />
                                    </div>
                        </div>
                        <div className="" id="category-list">
                            {level.length===1 && <h3 className="sd-titleText " >{t('choose')}</h3>}
                            {level.length===2 && <h3 className="sd-titleText " >{t('chooseSubCat')}</h3>}
                            {level.length===3 && <h3 className="sd-titleText " >{t('chooseSubProd')}</h3>}

                        
                        </div>
                        <div className="sd-grid lg:sd-grid-cols-3 sd-gap-4">
                            {Object.keys(categoriesSelection).map((category, index) => (
                                <CategoryCard
                                    key={index}
                                    title={formatText(category)}
                                    description={''}
                                    imageUrl={categoriesSelection[category][0]?.primaryImage}
                                    isApiLoading={isApiLoading}
                                    onClick={() => handleCategoryClick(category,categoriesSelection[category[0]]?.url)}
                                />
                            ))}

                        </div>
                        <div className="sd-flex sd-items-center sd-my-10 sd-justify-center">
                        {level[level.length - 1].level > 1 && (
                            <button onClick={gotoPrevious} id="category-back-btn" className="sd-cursor-pointer btn sd-btn-black sd-inline-block">
                                {t('back')}
                            </button>
                        )}
                        <a href={currentloc+'/support/category-selection/enterprise'} target="_blank" rel="noopener noreferrer" className="sd-cursor-pointer sd-sm-btn-grey sd-inline-block">{t('checkProduct')}
                        </a>
                        </div>
                        <div className="lg:sd-gap-9 sd--leading-[110%] sd-col-span-8 lg:sd-col-span-6">
                                <p className="lg:sd-text-[23px] sd-text-[19px] sd-mb-2">
                                    {t('locate')}
                                </p>
                                <p>
                                    {t('dontseePro')}  <a href={currentloc+'/app/products/product-detailweb/p/140'} className="sd-underline hover:sd-no-underline " target="_blank" rel="noopener noreferrer" >{t('checkDiscPro')}</a>
                                </p>
                            </div>
                        
                    </div>
                    {/* <div dangerouslySetInnerHTML={{__html:corpInfo}} className="lg:sd-gap-4 sd-col-span-8 lg:sd-col-span-12 lg:sd-col-start-5 lg:sd-pt-7 sd-mb-10"> */}

                    {/* </div> */}
            
                </div>
            </div>
        </section>
    );
};

export default CategorySelection;